export default "__VITE_ASSET__B8R2TUrJ__"